<template>
  <div class="info">
    <div class="hint-container">
      <div class="order-id-head">Digital-Order-ID</div>
      <div class="order-id-text">
        Please note the following number or copy to your clipboard.
      </div>
      <input
        id="order-id"
        class="order-id"
        v-bind:value="this.$store.state.subscription.order_id"
      />
    </div>
    <div class="hint-controls">
      <div v-on:click="print()" class="print-button">PRINT</div>
      <div v-on:click="copy()" class="copy-button">COPY TO CLIPBOARD</div>
      <!-- <div v-on:click="close()" class="close-button">CLOSE</div> -->
    </div>
    <div class="hint-text">
      After you have copied or printed the Digital-Order-ID you can close that
      browser tab and return to the Solarfox-Onlinemanagement. There you can add
      the Digital-Order-ID to add your datasource.
    </div>
  </div>
</template>

<script>
export default {
  name: "info-view",
  props: {
    title: String,
  },
  components: {},
  computed: {},
  methods: {
    print() {
      window.print();
    },
    copy() {
      let testingCodeToCopy = document.querySelector("#order-id");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        alert("Digital-Order-ID was copied " + msg);
      } catch (err) {
        alert("Oops, unable to copy");
      }
    },
    close() {
      window.open('', '_self', '');
      window.close();
    },
  },
};
</script>

<style scoped>
.info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.headline-container {
  display: flex;
  flex-direction: column;
}

.info-complete {
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 15px;
  margin-top: 35px;
  font-size: 18px;
}

.info-thx {
  font-size: 20px;
  margin-top: 10px;
}

.bold {
  font-weight: bold;
}
.email-hint {
  font-size: 14px;
  display: flex;
  margin-top: 10px;
}
.manage-link span {
  margin-right: 5px;
}

.manage-link {
  font-size: 14px;
  display: flex;
  margin-top: 10px;
}

.hint-container {
  display: flex;
  width: 100%;
  margin-top: 8%;
  padding: 20px;
  border: 1px solid #e9c535;
  border-radius: 3px;
  flex-direction: column;
  color: #505050;
}
.order-id-head {
  display: flex;
  font-weight: bold;
  font-size: 20px;
}
.order-id-text {
  display: flex;
}
.order-id {
  display: flex;
  font-size: 30px;
  margin-top: 20px;
  border: none;
  outline: none;
  background-color: white;
}
.hint-controls {
  display: flex;
  margin-top: 4%;
  color: white;
  font-size: 12px;
}
.print-button {
  display: flex;
  padding: 10px 20px;
  background-color: #a7a7a7;
  border-radius: 3px;
  margin-right: 10px;
  cursor: pointer;
}
.copy-button {
  display: flex;
  padding: 10px 20px;
  background-color: #a7a7a7;
  border-radius: 3px;
  margin-right: 10px;
  cursor: pointer;
}
.close-button {
  display: flex;
  padding: 10px 20px;
  background-color: #a7a7a7;
  border-radius: 3px;
  cursor: pointer;
}
.hint-text {
  margin-top: 4%;
  display: flex;
  color: #505050;
  font-size: 13px;
}
@media print {
  .right {
    width: 100%;
  }
  .hint-controls,
  .hint-text,
  .right .top,
  .right .bottom,
  .left {
    display: none;
  }
}
</style>
